export const zhTW = {
	title: 'JourneyNodes',
	language: '語言',
	connectionStrategy: '連線依據',
	connectionStrategyRelationFirst: '人物關聯優先',
	connectionStrategyBalanced: '平衡',
	connectionStrategyLabelFirst: '標籤相似優先',
	connectionDisplayMode: '線路顯示',
	connectionDisplayModeAll: '顯示所有線',
	connectionDisplayModeTagDerived: '只顯示標籤自動線',
	connectionDisplayModeExplicitOnly: '只顯示手動關係線',
	connectionDisplayModeTagDerivedFocus: '標籤線，聚焦後淡化其他線',
	gatePrompt: '使用 Google 登入',
	password: 'Google 登入',
	unlock: '解鎖',
	startupHeading: 'JourneyNodes',
	startupBody: '輕鬆清晰地建立人物關係圖，把角色、事件、職業與背景脈絡整理成可以探索的星圖。',
	startupPreviewEyebrow: '公開預覽',
	startupUnlockedEyebrow: '完整模式',
	startupPreviewMode: '預覽模式：可載入聖經與三國範本，也可建立空白專案（最多 10 個節點）。',
	startupUnlockedMode: '已解鎖：可載入完整範本、匯入封存，並不限節點數。',
	startupUnlockPrompt: '使用已開通的 Google 帳號解鎖完整模式',
	startupTemplatesTitle: '範本',
	startupTemplatesHint: '聖經與三國範本可直接預覽。',
	startupTemplatePublic: '預覽',
	startupTemplateUnlocked: '解鎖',
	startupActionsTitle: '開始方式',
	startupLoadTemplate: '載入範本',
	startupLoadingTemplate: '載入範本中...',
	startupLoadTemplateDescription: '載入目前的範例人物關係示範圖譜。',
	startupLoadThreeKingdomsTemplate: '三國演義範本',
	startupLoadThreeKingdomsTemplateDescription: '載入公版《三國演義》人物、戰役與身分背景關係圖。',
	startupLoadChristianBibleTemplate: '聖經範本',
	startupLoadChristianBibleTemplateDescription: '載入以和合本四福音書與舊約關鍵人物整理的人物關係圖。',
	startupLoadJinYongTemplate: '金庸範本',
	startupLoadJinYongTemplateDescription: '解鎖後載入金庸小說人物關係示範圖譜。',
	startupLoadArchive: '載入使用者自己的紀錄檔',
	startupLoadArchiveDescription: '選擇一個 .journeynodes 檔案，並以它進入主畫面。',
	startupBlankProject: '空白專案',
	startupBlankProjectDescription: '建立一個空白圖譜，從零開始新增節點。',
	startupBlankPreviewProjectDescription: '建立預覽用空白圖譜，完整模式前最多新增 10 個節點。',
	startupAbout: '關於',
	startupAboutPanelTitle: '關於',
	startupAboutPanelBody: '更多創作筆記、版本更新與作品脈絡會整理在部落格。',
	startupAboutBlog: '部落格',
	blankProjectTitle: '未命名旅程',
	previewNodeLimitReached: '預覽模式最多建立 10 個節點；若需要完整體驗請找原作者。',
	invalidPassword: '此 Google 帳號尚未開通完整模式。',
	unableToVerifyPassword: '目前無法驗證 Google 登入。',
	googleSignInLoading: '正在載入 Google 登入...',
	googleSignInVerifying: '正在驗證 Google 帳號...',
	googleSignInUnavailable: '尚未設定 Google 登入；公開預覽仍可使用。',
	googleAccountNotEnabled: '此 Google 帳號尚未開通完整模式，會維持預覽模式。',
	unableToVerifyGoogleSignIn: '目前無法驗證 Google 登入，請稍後再試。',
	googleAccountPanelLabel: 'Google 帳號狀態',
	googleSignedInAs: '目前登入帳號',
	googleSignOut: '登出 Google',
	googleSignOutDescription: '清除本次完整模式授權',
	search: '搜尋節點',
	searchHint: '輸入節點名稱即可快速定位。',
	searchJump: '可直接跳至符合的節點。',
	all: '全部',
	human: '人物',
	project: '專案',
	occupation: '職業',
	noExact: '沒有完全符合結果，以下是近似候選。',
	clear: '清除',
	recent: '最近',
	exact: '完全符合',
	nearMatch: '近似',
	create: '建立',
	createNode: '建立節點',
	saveNode: '儲存節點',
	relationshipPanelTitle: '關係編輯器',
	relationshipPanelEyebrow: '顯性關係 pair',
	relationshipSummaryTitle: '顯性關係',
	manageRelationships: '管理關係',
	viewRelationshipDetails: '查看關係詳情',
	noExplicitRelationships: '目前尚無顯性關係。',
	relationshipTargetTypeFilter: '對象類型',
	relationshipTargetNode: '關係對象',
	relationshipTargetPlaceholder: '選擇另一個節點',
	relationshipPanelEmptyState: '先選擇另一個節點，以建立雙向關係。',
	relationshipPanelExistingPair: '這組關係已存在，可直接調整 labels 後再儲存。',
	relationshipPanelCreateGuidance: '任一方向至少填入一個 label，就能建立這組關係。',
	relationshipReadonlyNotice: '唯讀圖譜可以查看關係，但不能新增、修改或刪除。',
	relationshipSummaryOverflowHint: '線上的摘要已壓縮顯示，請開啟詳情查看完整 labels。',
	relationshipMixedSummaryHint: '這組關係也有系統自動推導出的連線理由。',
	relationshipDerivedReasonsTitle: '系統自動推導的連線理由',
	relationshipDirectionNoLabels: '此方向尚未填入 label。',
	relationshipBlockedTitle: '目前無法儲存這組關係',
	relationshipBlockedHint: '請先修正以下問題，再儲存這組 pair。',
	relationshipSaveAction: '儲存關係',
	relationshipDeleteAction: '移除此關係',
	relationshipValidationEmpty: '至少要先填入一個關係 label。',
	relationshipValidationDuplicate: '同一方向不能出現重複 label。',
	relationshipValidationMissingTarget: '請先選擇有效的既有節點作為關係對象。',
	relationshipValidationSelf: '節點不能和自己建立顯性關係。',
	relationshipDetailTitle: '關係詳情',
	relationshipDetailEyebrow: '關係詳情',
	relationshipDetailEmpty: '先從關係摘要或編輯器選擇一組關係。',
	relationshipDetailEditAction: '編輯這組關係',
	edit: '編輯',
	editFocusedNode: '編輯焦點節點',
	editAllFields: '編輯全部欄位',
	deleteNode: '刪除',
	deleteNodeConfirmTitle: '刪除節點',
	deleteNodeConfirmPrompt: '確定要刪除節點「{name}」嗎？此動作無法復原。',
	deleteNodeConfirmAction: '確認刪除',
	cancel: '取消',
	close: '關閉',
	archiveExport: '匯出 .journeynodes',
	archiveExportDialogTitle: '匯出封存',
	archiveExportFileName: '檔名',
	archiveExportTitle: '封存標題',
	archiveExportSyncTitle: '同步回寫目前圖譜標題',
	archiveExportSaveMode: '儲存方式',
	archiveSaveModePicker: '讓我選擇儲存位置',
	archiveSaveModeDownload: '直接下載到瀏覽器預設位置',
	archiveExportWarningsPreview: '匯出前警告：{warnings}',
	archiveSavePickerUnavailable: '目前瀏覽器不支援直接選位置，會使用預設下載位置。',
	archiveExportConfirm: '確認匯出',
	archiveExporting: '匯出封存中...',
	archiveImport: '匯入 .journeynodes',
	archiveImporting: '匯入封存中...',
	archiveToolbarHint: '匯出會保留目前節點佈局；匯入會一次取代目前圖譜。',
	archiveLockedContactAuthor: '匯出需要完整模式。請使用已開通的 Google 帳號登入。',
	archiveImportConfirmTitle: '取代目前圖譜',
	archiveImportReplacePrompt: '目前圖譜「{current}」會被 archive「{next}」取代。是否繼續？',
	archiveImportReplace: '取代目前圖譜',
	archiveImportWarningsPreview: '匯入前警告：{warnings}',
	archiveSpatialStatusLabel: '3D 佈局狀態',
	archiveSpatialRoundTripStatus: '3D 佈局可直接 round-trip。',
	archiveSpatialFallbackStatus: '這份 archive 會先自動補齊 3D 深度再開啟。',
	archiveSpatialWarningsListTitle: '3D 佈局警告',
	archiveLoadedSample: '已載入範例封存：{title}。匯入另一個 .journeynodes 檔案即可取代目前圖譜。',
	archiveExported: '已匯出 {title}。',
	archiveExportedWarnings: '已匯出 {title}，但有警告：{warnings}',
	archiveImported: '已匯入 {title}。',
	archiveImportedWarnings: '已匯入 {title}，但有警告：{warnings}',
	archiveStatusSpatialRoundTripReady: '3D 佈局可直接 round-trip。',
	archiveStatusSpatialFallbackApplied: '已套用 3D 佈局 fallback。',
	archiveSampleLoadFailed: '無法載入預設範例封存。{detail}',
	archiveImportFailed: '無法匯入這個 .journeynodes 檔案。{detail}',
	archiveImportFailedTitle: '封存匯入失敗',
	archiveImportFailureLayoutNote: '目前圖譜與已保存的 3D 佈局都會保持不變。',
	'workspace.mode.group': '工作區模式',
	'workspace.mode.current': '目前工作區',
	'workspace.mode.controls': '工作區控制',
	'workspace.mode.controlsShow': '展開控制面板',
	'workspace.mode.controlsHide': '收起控制面板',
	'workspace.mode.2d': '2D',
	'workspace.mode.3d': '3D',
	'workspace.mode.outline': '綱要',
	'workspace.mode.2dLabel': '2D 星圖',
	'workspace.mode.3dLabel': '3D 宇宙圖',
	'workspace.mode.outlineLabel': '綱要工作區',
	'workspace.mode.3dHint': '保留同一份圖譜資料，改用更有空間感的鏡頭穿梭節點。',
	'workspace.mode.3dTools': '3D 工具',
	'workspace.mode.3dNodeList': '3D 節點清單',
	'workspace.mode.3dGamepad': '3D 導航控制',
	'workspace.mode.3dNavigate': '巡覽場景',
	'workspace.mode.3dMoveNode': '移動節點',
	'workspace.mode.3dMoveNodeReadonly': '唯讀圖譜不可移動節點。',
	'workspace.mode.3dNavigateHint': '按住中鍵或 Shift+拖曳可旋轉，滾輪可放大縮小。',
	'workspace.mode.3dFlyHint': 'W/A/S/D 前進與側移，Q/E 升降；按住 Shift 可加速。',
	'workspace.mode.3dLabels': '人物名稱',
	'workspace.mode.3dLabelsHint': '各類型名稱可分別開關，並依與鏡頭距離自動縮放。',
	'workspace.mode.3dLabelsVisible': '人物名稱已顯示',
	'workspace.mode.3dLabelsHidden': '人物名稱已隱藏',
	'workspace.mode.3dLabelTypeVisibility': '3D 名稱顯示類型',
	'workspace.mode.3dLabelTypesVisible': '已開啟 {count} 種名稱',
	'workspace.mode.3dColor': '顏色',
	'workspace.mode.3dBrightness': '亮度',
	'workspace.mode.3dBrightnessValue': '亮度 {value}',
	'workspace.mode.3dColorForType': '{name} 顏色',
	'workspace.mode.3dBrightnessForType': '{name} 亮度',
	'workspace.mode.3dMoveNodeHint': '拖曳球體即可移動節點；放開提交，Esc 取消。',
	'workspace.mode.3dPlacementActive': '放置預覽',
	'workspace.mode.3dPlacementNode': '正在移動 {name}',
	'workspace.mode.3dBeginFocusedPlacement': '準備移動 {name}',
	'workspace.mode.3dPlacementDepth': '深度 {depth}',
	'workspace.mode.3dPlacementOffset': '位移 X {x} / Y {y} / Z {z}',
	'workspace.mode.3dPanCluster': '平移',
	'workspace.mode.3dOrbitCluster': '旋轉',
	'workspace.mode.3dZoomCluster': '縮放',
	'workspace.mode.3dPanLeft': '向左平移 3D 視角',
	'workspace.mode.3dPanRight': '向右平移 3D 視角',
	'workspace.mode.3dPanUp': '向上平移 3D 視角',
	'workspace.mode.3dPanDown': '向下平移 3D 視角',
	'workspace.mode.3dRotateLeft': '向左旋轉視角',
	'workspace.mode.3dRotateRight': '向右旋轉視角',
	'workspace.mode.3dRotateUp': '向上仰視視角',
	'workspace.mode.3dRotateDown': '向下俯視視角',
	'workspace.mode.3dZoomIn': '放大 3D 視角',
	'workspace.mode.3dZoomOut': '縮小 3D 視角',
	'workspace.mode.3dDepthLegend': '近景、中景、遠景標籤會在巡覽時保持可讀。',
	'workspace.mode.3dVisibleCount': '目前可見 {count} 個節點',
	'workspace.mode.3dOverviewHint': '返回全圖會重新置中目前可見圖譜，但不會清掉你正在進行的工作上下文。',
	'workspace.appearance.eyebrow': '外觀',
	'workspace.appearance.title': '節點外觀',
	'workspace.appearance.hint': '可依類型調整名稱顯示、顏色與亮度，2D/3D 共用同一份設定。',
	'workspace.appearance.typeVisibility': '節點名稱顯示類型',
	'workspace.appearance.color': '顏色',
	'workspace.appearance.brightness': '亮度',
	'workspace.appearance.brightnessValue': '亮度 {value}',
	'workspace.appearance.colorForType': '{name} 顏色',
	'workspace.appearance.brightnessForType': '{name} 亮度',
	'workspace.mode.3dDepthNear': '近景',
	'workspace.mode.3dDepthMid': '中景',
	'workspace.mode.3dDepthFar': '遠景',
	'workspace.outline.title': '綱要工作區',
	'workspace.outline.searchPlaceholder': '搜尋列中的節點、摘要或關聯',
	'workspace.outline.count': '可見節點',
	'workspace.outline.sort': '排序',
	'workspace.outline.sortDirection': '排序方向',
	'workspace.outline.sortAsc': '由小到大',
	'workspace.outline.sortDesc': '由大到小',
	'workspace.outline.filter': '綱要篩選',
	'workspace.outline.groupByType': '依類型分組',
	'workspace.outline.ungrouped': '不分組',
	'workspace.outline.returnTo2d': '返回 2D 星圖',
	'workspace.outline.returnTo3d': '返回 3D 宇宙圖',
	'workspace.outline.allResults': '全部結果',
	'workspace.outline.type': '類型',
	'workspace.outline.connections': '關聯數',
	'workspace.outline.actions': '動作',
	'workspace.outline.locate': '定位到圖上',
	'workspace.outline.inlineEdit': '快速編輯',
	'workspace.outline.inlineEditNode': '快速編輯 {name}',
	'workspace.outline.inlineSave': '儲存列編輯',
	'workspace.outline.inlineCancel': '取消列編輯',
	'workspace.outline.fullEditor': '完整編輯',
	'workspace.outline.lockedByEditor': '這列目前由完整編輯器鎖定。',
	'workspace.outline.emptyTitle': '目前沒有可顯示的節點',
	'workspace.outline.emptyBody': '調整本地篩選或搜尋條件，或直接在這裡建立新的節點。',
	'workspace.outline.workflowHint': 'AI 設定、AI 工作區與封存匯入匯出在綱要開啟時仍可從主 HUD 直接使用。',
	'workspace.outline.locateHint': '定位會返回上一個圖譜模式，並保持目標節點的聚焦狀態。',
	topConnections: '最高關聯',
	returnToFullMap: '返回全圖',
	completeNodeDetails: '完整節點資訊',
	coreFields: '核心欄位',
	humanRelations: '人物關聯',
	projectRelations: '專案關聯',
	occupationRelations: '職業關聯',
	visualMetadata: '視覺資訊',
	systemMetadata: '系統資訊',
	notes: '備註',
	customFields: '自訂欄位',
	noNotes: '尚無備註。',
	noCustomFields: '尚無自訂欄位。',
	displayName: '顯示名稱',
	summaryLabel: '摘要',
	referenceHumanPlaceholder: 'h2 或 Grace Hopper',
	referenceProjectPlaceholder: 'p1 或 Analytical Engine',
	referenceOccupationPlaceholder: 'o1 或 Mathematician',
	tags: '標籤',
	imageSource: '圖片來源',
	presetAvatarId: '預設頭像 ID',
	uploadedImageAssetId: '上傳圖片資產 ID',
	nodeId: 'Node ID',
	createdAt: '建立時間',
	updatedAt: '更新時間',
	localTimeLabel: '本地時間',
	originTimeZoneLabel: '原始時區',
	timeZoneAsiaTaipei: '台北時間',
	occupationIds: '職業 IDs',
	projectIds: '專案 IDs',
	relatedHumanIds: '關聯人物 IDs',
	participantHumanIds: '參與人物 IDs',
	relatedOccupationIds: '關聯職業 IDs',
	relatedProjectIds: '關聯專案 IDs',
	typicalProjectIds: '典型專案 IDs',
	noSummaryYet: '尚無摘要。',
	none: '無',
	fallbackPortraitActive: '使用替代頭像顯示',
	uploadedPortraitActive: '使用已上傳圖片',
	presetPortraitActive: '使用預設角色頭像',
	fieldLabel: '欄位標籤',
	fieldValue: '欄位內容',
	valueType: '值類型',
	displayOrder: '顯示順序',
	addField: '新增欄位',
	removeField: '刪除欄位',
	presetAvatarCatalog: '預設頭像圖庫',
	imageSourceFallback: '替代圖片',
	imageSourcePresetAvatar: '預設角色頭像',
	imageSourceUpload: '已上傳圖片',
	readOnlyViewer: '唯讀檢視：只有擁有者可以編輯這個圖譜。',
	'settings.workspace.title': 'AI 設定',
	'settings.workspace.nav': '設定導覽',
	'settings.workspace.graphScoped': '這些設定跟隨目前圖譜 archive 保存。',
	'settings.deidentification.title': '去識別化',
	'settings.deidentification.description': '先保護 Human 人名，再調整欄位文字、標籤與手動規則。',
	'settings.deidentification.enabled': '啟用圖譜層級 AI 去識別化',
	'settings.deidentification.candidates': '去識別化候選',
	'settings.deidentification.showHumans': '聚焦人物候選',
	'settings.deidentification.showAll': '顯示全部候選',
	'settings.deidentification.replacementPlaceholder': '替換文字',
	'settings.deidentification.manualRules': '手動規則',
	'settings.deidentification.manualOriginal': '原始關鍵字',
	'settings.deidentification.manualReplacement': '替換後文字',
	'settings.deidentification.addRule': '新增規則',
	'settings.deidentification.removeRule': '刪除規則',
	'settings.deidentification.manualRuleInvalid': '原始值與替換值都必須填寫。',
	'settings.deidentification.preview': '本地預覽',
	'settings.deidentification.previewInput': '預覽輸入',
	'settings.deidentification.previewPlaceholder': '貼上示例文字以預覽遮罩與還原結果。',
	'settings.deidentification.runPreview': '執行預覽',
	'settings.deidentification.maskedResult': '去識別化結果',
	'settings.deidentification.restoredResult': '還原結果',
	'settings.deidentification.conflictWarning': '部分規則的替換值會造成還原歧義，因此已被阻擋。',
	'settings.deidentification.readonly': '唯讀模式：只能檢視設定。',
	'settings.deidentification.promptContract': 'Prompt 契約與範例回覆',
	'settings.deidentification.createNodePromptContract': '新增節點 prompt 契約與範例 JSON',
	'settings.deidentification.createNodeSystemPrompt': '新增節點 system prompt',
	'settings.deidentification.createNodeExampleJson': '新增節點範例 JSON',
	'settings.deidentification.createNodeExampleInvalid': '新增節點範例 JSON 必須是有效的單一 node 物件。',
	'settings.deidentification.bucket.human': '人物',
	'settings.deidentification.bucket.field': '欄位',
	'settings.deidentification.bucket.tag': '標籤',
	'settings.future.title': '未來設定',
	'settings.future.description': '之後的圖譜設定會集中加入這裡。',
	'workspace.aiAssist.title': 'AI 工作區',
	'workspace.aiAssist.description': '準備原始 JSON、去識別化 JSON、可複製 prompt，並驗證貼回的 AI 回覆。',
	'workspace.aiAssist.pageNav': 'AI 工作區子頁面',
	'workspace.aiAssist.readonly': '唯讀模式會鎖定已保存設定，但仍可檢視工作區。',
	'workspace.aiAssist.stale': '目前工作區內容已過期，請重新建立 bundle 與 prompt。',
	'workspace.aiAssist.selectedNodePage': '編輯節點',
	'workspace.aiAssist.selectedNodePageHint': '選擇既有節點、產生 bundle、匯入 AI 編輯結果。',
	'workspace.aiAssist.createNodePage': '新增節點',
	'workspace.aiAssist.createNodePageHint': '從自然語言需求與 JSON 建立新的節點。',
	'workspace.aiAssist.selectedNodes': '已選節點',
	'workspace.aiAssist.noneSelected': '尚未選擇任何節點。',
	'workspace.aiAssist.selectionHint': '勾選節點後，原始 JSON、去識別化 JSON 與 prompt 會自動同步更新。',
	'workspace.aiAssist.searchNodes': '搜尋節點',
	'workspace.aiAssist.nodeType': '節點類型',
	'workspace.aiAssist.filterAll': '全部',
	'workspace.aiAssist.noMatchingNodes': '目前沒有符合搜尋與篩選條件的節點。',
	'workspace.aiAssist.buildSource': '建立原始 JSON',
	'workspace.aiAssist.buildMasked': '執行去識別化',
	'workspace.aiAssist.buildPrompt': '產生 prompt 預覽',
	'workspace.aiAssist.rawJson': '原始 JSON bundle',
	'workspace.aiAssist.maskedJson': '去識別化 JSON bundle',
	'workspace.aiAssist.promptPreview': 'Prompt 預覽',
	'workspace.aiAssist.userPrompt': '使用者 prompt',
	'workspace.aiAssist.userPromptPlaceholder': '例如：請根據上述節點補充人物背景、專案脈絡與缺少的關聯。',
	'workspace.aiAssist.createNodeSection': '新增節點',
	'workspace.aiAssist.createNodeHint': '用自然語言描述想新增的節點。這個流程會依 AI 設定中的新增節點 prompt 契約生成單一 node prompt，貼回 JSON 後可直接驗證與新增。',
	'workspace.aiAssist.createNodeRequest': '新增節點需求',
	'workspace.aiAssist.createNodeRequestPlaceholder': '例如：新增一個描述新合作專案的節點，包含關係與重點欄位。',
	'workspace.aiAssist.createNodePromptPreview': '新增節點 prompt 預覽',
	'workspace.aiAssist.createNodeExample': '新增節點範例 JSON',
	'workspace.aiAssist.createNodeJson': '新增節點 JSON',
	'workspace.aiAssist.importActions': '匯入動作',
	'workspace.aiAssist.importOperations': '匯入 AI 變更',
	'workspace.aiAssist.createNodeAction': '新增節點',
	'workspace.aiAssist.createNodeResponseValid': '這份新增節點 JSON 符合契約。',
	'workspace.aiAssist.copyCreateNodePrompt': '複製新增節點 prompt',
	'workspace.aiAssist.expandRawJson': '放大原始 JSON',
	'workspace.aiAssist.expandMaskedJson': '放大去識別化 JSON',
	'workspace.aiAssist.expandPromptPreview': '放大 prompt 預覽',
	'workspace.aiAssist.diff': '替換差異',
	'workspace.aiAssist.responseDraft': '貼回的 AI 回覆',
	'workspace.aiAssist.responseValid': '這份 AI 回覆符合 operations[] 契約。',
	'workspace.aiAssist.systemPrompt': 'System prompt',
	'workspace.aiAssist.exampleResponse': '範例回覆 JSON',
	'workspace.aiAssist.copyRawJson': '複製原始 JSON',
	'workspace.aiAssist.copyMaskedJson': '複製去識別化 JSON',
	'workspace.aiAssist.copyPromptPreview': '複製 prompt 預覽',
	'workspace.aiAssist.copied': '已複製全文。',
	'workspace.aiAssist.copiedShort': '已複製',
	'archive.aiConfig.loaded': '已從 archive 還原 AI 設定。',
	'archive.aiConfig.legacyFallback': '此 archive 沒有 AI 設定，因此已初始化安全預設值。',
	'archive.aiConfig.invalid': '部分 AI 設定無法還原，已改用安全預設值。',
	'regression.aiSettings.readonly': '唯讀檢視',
	validationDisplayNameRequired: '顯示名稱為必填。',
	validationCustomFieldLabelRequired: '自訂欄位標籤為必填。',
	validationCustomFieldIdsUnique: '自訂欄位 ID 必須唯一。',
	validationTagsInvalid: '標籤只能包含文字、數字與空白，多個標籤請用逗點分隔。',
	validationProjectSelfReference: '專案不可指向自己。',
	hiddenByFilter: '被篩選隱藏'
} as const;
